import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslateModule } from '@ngx-translate/core';

export interface AppMenuItem {
  labelKey: string;
  icon?: string;
  routerLink?: string[];
  items?: AppMenuItem[];
  /** When true, link is active only on exact URL; when false/undefined, active on URL prefix (e.g. /cases active for /cases/123). */
  exact?: boolean;
}

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    NgIcon,
    TranslateModule,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  @Input() items: AppMenuItem[] = [];
  @Output() redirected = new EventEmitter<void>();

  constructor(private readonly router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.redirected.emit();
      }
    });
  }
}
